module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['cart'],
    style: (_vm.styleObject)
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "shimmer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-897edf48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ShimmerEffectPlaceHolder.vue
// module id = 1076
// module chunks = 3 16 23 28 30 31 43 49 60 61